<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col-8">
                <h3 class="page-title">Page Not Found !</h3>
              </div>
              <div class="col-4 text-sm-end">
                <div class="title-head">
                  <div class="head-icons">
                    <router-link
                      to="/blank-page"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      data-bs-original-title="Refresh"
                      ><i class="ti ti-refresh-dot"></i
                    ></router-link>
                    <a
                      href="javascript:void(0);"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      data-bs-original-title="Collapse"
                      id="collapse-header"
                      ><i class="ti ti-chevrons-up"></i
                    ></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: "Blank Page",
    };
  },
};
</script>
